import type { HelpFile } from '../../types/help'
import { PartyDetailTestIds } from '../../../testids/PartyDetailTestIds'

export const partyDetailHelp: HelpFile = {
  docPage: '/docs/identity/parties',
  texts: {
    [PartyDetailTestIds.partyDetailPage]:
      'Detailseite einer Partei — Person, Organisation oder KI-Agent — mit Attributen, Identitäten, Hierarchie und Beziehungen.',
    [PartyDetailTestIds.sectionAttributes]:
      'Attributwerte dieser Partei, aus den für den Parteityp konfigurierten Attributdefinitionen.',
    [PartyDetailTestIds.sectionIdentities]:
      'Digitale Identitäten dieser Partei — jede steht für die Partei in einem bestimmten Kontext wie Mitarbeiter oder Kunde.',
    [PartyDetailTestIds.sectionPartyHierarchy]:
      'Organisationshierarchie — übergeordnete Parteien, direktes Elternelement und direkte Kinder.',
    [PartyDetailTestIds.sectionRelationships]:
      'Beziehungen zu anderen Parteien — Vorgesetzter, Mentor und benutzerdefinierte Beziehungstypen.',
    [PartyDetailTestIds.btnToggleOrgTree]:
      'Organisationsbaum dieser Partei ein- oder ausblenden.',
    [PartyDetailTestIds.colType]: null,
    [PartyDetailTestIds.colCreatedAt]: null,
    [PartyDetailTestIds.colLifecycleState]:
      'Aktuelle Lebenszyklus-Phase der verknüpften Entität.',
    [PartyDetailTestIds.btnAddRelationshipPrefix()]:
      'Eine Gegenpartei zu diesem Beziehungs-Abschnitt hinzufügen. Deaktiviert, sobald die maximale Anzahl an Beziehungen erreicht ist.',
    [PartyDetailTestIds.btnRemoveRelationshipPrefix()]:
      'Diese Beziehung beenden — die Zeile bleibt mit gesetztem Enddatum in der Audit-Historie erhalten, ist aber nicht mehr aktiv.',
    [PartyDetailTestIds.dialogAddRelationshipPrefix()]:
      'Eine Gegenpartei vom in der Schemadefinition erlaubten Parteityp auswählen und mit Bestätigen die Beziehung anlegen.',
    [PartyDetailTestIds.dialogRemoveRelationshipPrefix()]:
      'Bestätigen, dass die Beziehung beendet werden soll. Abbrechen behält die Zeile aktiv; Bestätigen setzt das Enddatum.',
    [PartyDetailTestIds.comboboxAddRelationshipPrefix()]:
      'Tippen Sie, um Parteien des erlaubten Gegenpartei-Typs zu filtern.',
    [PartyDetailTestIds.btnConfirmAddRelationshipPrefix()]:
      'Die Beziehung zur ausgewählten Gegenpartei anlegen.',
    [PartyDetailTestIds.btnCancelAddRelationshipPrefix()]:
      'Den Dialog schließen, ohne eine Beziehung anzulegen.',
    [PartyDetailTestIds.btnConfirmRemoveRelationshipPrefix()]:
      'Die Beziehung beenden — die Zeile ist nicht mehr aktiv, bleibt aber in der Audit-Historie erhalten.',
    [PartyDetailTestIds.btnCancelRemoveRelationshipPrefix()]:
      'Den Dialog schließen, ohne die Beziehung zu beenden.',
  },
}
